import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { User } from '~/auth/model/user';
import { MenuItemInterface } from '~/component/header/login/menu/interfaces/menu-item.interface';
import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';
import { ToggleService } from '~/toggles/services/toggle.service';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';

import { HeaderVariantEnum } from './enums/variant.enum';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() public dropdownMenuItems: MenuItemInterface[][] = [];
  @Input() public homeLink: string;
  @Input() public logo = LogoTypeEnum.Regular;
  @Input() public logoHeight = 28;
  @Input() public user: User;
  @Input() public variant = HeaderVariantEnum.Attendee;
  @Output() public login = new EventEmitter();
  public readonly toggleNameEnum = ToggleNameEnum;
  public skipLinkUrl: string;

  constructor(
    protected readonly toggleService: ToggleService,
    private readonly router: Router
  ) {}

  public ngOnInit(): void {
    this.skipLinkUrl = decodeURI(this.router.url + '#main-content');
  }

  public get headerClass(): string {
    if (this.variant === HeaderVariantEnum.Organizer) {
      return 'header--organizer';
    }
    return '';
  }

  public get isAttendee(): boolean {
    return this.variant === HeaderVariantEnum.Attendee;
  }

  public loginButtonClicked(): void {
    this.login.emit();
  }
}
